import { Record } from '../transit'

const Lesson = Record({
  id: '',
  name: '',
  instructions: '',
  createdBy: null,
  subject: null,
  text: '',
  prologueText: '',
  youtubeVideo: '',
  baseLang: '',
  foreignLang: '',
  type: '',
  isPublic: false,
  words: [],
  wordbox: null,
  options: null,
  openQuestions: [],
  savedByUsers: [],
  tags: [],
}, 'lesson')

export default Lesson



// WEBPACK FOOTER //
// ./src/common/lessons/Lesson.js